import {Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import {DatasetService} from 'app/main/components/dataset/services/dataset.service';
import {DatasetActionContainerService, DatasetEvents, IDatasetEvent} from 'app/main/components/dataset/services/dataset-action-container.service';
import {AppService} from 'app/services/app.service';
import { PageClosureContainerService } from 'app/main/pages/page-closure-container.service';
import { Subject } from 'rxjs';
import { DatasetRecordService } from '../../services/dataset-record.service';
import { takeUntil } from 'rxjs/operators';
import { IPaginationResponse } from 'app/interfaces';

export interface IPriceRulesDialogData {
	parentDatasetACS: DatasetActionContainerService;
	parentRecordId: string;
	parentFieldKey: string;
}

@Component({
    selector: 'actual-trip-group-resources',
    templateUrl: 'dialog.component.html',
    // styleUrls: ['dialog.component.scss'],
    providers: [PageClosureContainerService, DatasetActionContainerService, DatasetRecordService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ActualTripGroupResourcesComponent implements OnInit, OnDestroy{

	loading = false;
	protected _unsubscribeAll: Subject<void>;

	constructor(
		public datasetACS: DatasetActionContainerService,
		public datasetRS: DatasetRecordService,
		public appService: AppService,
		public datasetService: DatasetService,
		protected dialog: MatDialog,
		public dialogRef: MatDialogRef<ActualTripGroupResourcesComponent>,
		@Inject(MAT_DIALOG_DATA) public data: IPriceRulesDialogData
	) {
		this._unsubscribeAll = new Subject();
	}

	ngOnInit(): void{
		this.datasetACS.init({
			datasetCode: this.data.parentDatasetACS.datasetCode,
			actionCode: 'detail',
			parentDatasetACS: this.data.parentDatasetACS,
			fetchData: false,
			parentDatasetRS: this.datasetRS
		})
		.pipe(takeUntil(this._unsubscribeAll))
		.subscribe( ready => {
			if(!ready) return;
			this.datasetRS.recordId = this.data.parentRecordId;
			this.datasetRS.init()
			.pipe(takeUntil(this._unsubscribeAll))
			.subscribe(readyRecordService => {
				if(!readyRecordService) return;
				this.datasetRS.reload();
			});
		});
		// this.loadLastCreated();
	}

	ngOnDestroy(): void{
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}

	onCloseClick(): void{
		this.dialogRef.close(false);
	}

	onDatasetEvent(event: IDatasetEvent): void{
		// this.loadLastCreated();
	}

	loadLastCreated(): void{
		this.datasetService.get<IPaginationResponse<any>>('/dataset/actual_trip_group_trip_resources', {
			foreign_parent_record_id: this.data.parentRecordId,
			foreign_parent_field_key: this.data.parentFieldKey,
			sortBy: 'created_at',
			sortDirection: 'desc',
			perPage: 1,
		}).subscribe(result => {
			if(result && result.items && result.items.length){
				this.datasetACS.putDatasetData('actual_trip_group_trip_resources_created', result.items[0]);
			}else{
				this.datasetACS.putDatasetData('actual_trip_group_trip_resources_created', null);
			}
		});
	}
}
